<div class="card">
    <p-accordion>
        <p-accordionTab header="Oversign" [selected]="true">
            <div class="sticky-table-container">
                <p-table stripedRows [value]="oversignData"
                    [rowHover]="true"
                    tableStyleClass="table p-datatable-full tabulator"
                    selectionMode="multiple"
                    [(selection)]="selectedOversignData"
                >
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="4" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr class="tabulator-header" style="height: 2.5rem">
                            <th style="width: 2.5rem">
                                <div class="tabulator-col-content">
                                    <div class="tabulator-col-title">
                                        <div class="tabulator-header-filter">
                                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="TaskCombo">
                                <div class="tabulator-col-content">
                                    <div class="tabulator-col-title">
                                        <div class="tabulator-header-filter">
                                            Task | PI | SI | Class
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="EmployeeWorkDate">
                                <div class="tabulator-col-content">
                                    <div class="tabulator-col-title">
                                        <div class="tabulator-header-filter">
                                            Work Date
                                        </div>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="EmployeeHours">
                                <div class="tabulator-col-content">
                                    <div class="tabulator-col-title">
                                        <div class="tabulator-header-filter">
                                            Hours
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-oversign>
                        <tr class="tabulator-row p-selectable-row">
                            <td class="p-datatable-cell disabled">
                                <p-tableCheckbox
                                    [value]="oversign"
                                ></p-tableCheckbox>
                            </td>
                            <td class="p-datatable-cell disabled">
                                {{ oversign.TaskCombo }}
                            </td>
                            <td class="p-datatable-cell disabled">
                                {{
                                    oversign.EmployeeWorkDate
                                        | date: 'MM/dd/yyyy'
                                }}
                            </td>
                            <td class="p-datatable-cell disabled">
                                {{ oversign.EmployeeHours }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <button
                type="button"
                pButton
                (click)="oversignTimeClicked()"
                label="Oversign"
            ></button>
        </p-accordionTab>
    </p-accordion>
</div>
